type Props = { size?: number; title?: string; className?: string };

/**
 * Orla's mark: an open ring with a dot. Drawn here from Oliver's mock-up of 20 September
 * 2026 because no vector master of it exists yet; replace with the master when there is one.
 */
export function OrlaMark({ size = 28, title, className }: Props) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <path
        d="M41.2 9.4a24 24 0 1 1-18.4 0"
        fill="none"
        stroke="currentColor"
        strokeWidth="9"
        strokeLinecap="round"
      />
      <circle cx="32" cy="32" r="7.5" fill="currentColor" />
    </svg>
  );
}
